import React from 'react';
import logov from 'shared/src/logo-v.png';
import { classNames, cn } from 'shared/src/utils/classNames';

export default function LoadingOverlay({ infoText, animate, isPreview = true }: { infoText: string; animate: boolean; isPreview?: boolean }) {
  return (
    <div className="cursor-wait space-y-8 flex flex-col justify-center min-h-0">
      {isPreview ? (
        <div className="flex justify-center -mb-4">
          <div className="inline-block mx-auto text-white uppercase px-2 py-1 rounded-full font-semibold bg-ev-blue">Preview</div>
        </div>
      ) : null}
      <img className={cn(animate ? 'animate-heartbeat' : '', 'w-1/2 mx-auto')} src={logov} alt="EasyVote check logo" />
      <span className="text-sm text-center font-semibold">{infoText}</span>
    </div>
  );
}
